import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
} from "@angular/core";
import { Subscription } from "rxjs";
import { LoginStateService } from "../../services/login-state.service";
import { Router } from "@angular/router";
import { StringService } from "../../services/string.service";
import { AuthenticationService } from "../../services/authentication.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  standalone: true,
  imports: [],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() appTitle: string;
  loggedIn: boolean = false;

  private subs: Subscription[] = [];

  constructor(
    public loginStateService: LoginStateService,
    public router: Router,
    public stringService: StringService,
    private authenticator: AuthenticationService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    // Re-run change detection when the connection strings or regular
    // strings are loaded by the parent AppComponent. This is needed
    // because in v22 standalone architecture, the parent mutating a
    // service field doesn't automatically trigger a CD pass on the
    // child. markForCheck() schedules a check on the next tick.
    this.subs.push(
      this.stringService.connectionStringsChange.subscribe(() => {
        this.cdr.markForCheck();
      }),
    );
    this.subs.push(
      this.stringService.change.subscribe(() => {
        this.cdr.markForCheck();
      }),
    );
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

  logout() {
    this.authenticator.logout();
  }
}
